"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var progress_service_1 = require("./progress.service");
var pack_level_service_1 = require("./pack-level.service");
var event_service_1 = require("./event.service");
var storage_service_1 = require("./storage.service");
var Module = window.Module;
var UserService = (function () {
    function UserService(http, progressService, packLevelService, eventService, storageService) {
        this.http = http;
        this.progressService = progressService;
        this.packLevelService = packLevelService;
        this.eventService = eventService;
        this.storageService = storageService;
        this.authorized = false;
        this.getCurrentUser();
    }
    UserService.prototype.getCurrentUser = function () {
        var _this = this;
        var headers = new http_1.Headers({
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        });
        this.userPromise = this.http.get('/api/v1/auth/user', { headers: headers })
            .toPromise()
            .then(function (data) {
            _this.user = data.json();
            _this.userToken = _this.user.token;
            _this.authorized = true;
            _this.user;
            var tokenFromStorage = _this.storageService.get('userToken');
            if (!tokenFromStorage && _this.storageService.getArray('PlayedLevels').length) {
                // только залогинился
                _this.eventService.fire('showModalHelpProgress');
            }
            else if (tokenFromStorage && tokenFromStorage !== _this.userToken) {
                // два разных
                _this.replaceProgress();
            }
            else {
                _this.sync();
            }
            _this.storageService.saveString('userToken', _this.userToken);
        }, function (err) {
            _this.authorized = false;
            if (_this.storageService.get('userToken')) {
                _this.storageService.remove('userToken');
                _this.progressService.resetProgress();
                _this.eventService.fire('getStarsProgress');
            }
        });
    };
    UserService.prototype.sync = function () {
        var _this = this;
        var lastSyncDate = this.storageService.get('SyncDate');
        return this.userPromise
            .then(function () {
            if (!_this.authorized) {
                return;
            }
            var progress = {
                app: 'Geom',
                unlocked_levels: _this.progressService.unlockedLevels,
                played_levels: _this.progressService.playedLevels,
                skipped_levels: _this.progressService.skippedLevels,
                level_results: [],
                timestamp: _this.storageService.get('SyncTimestamp')
            };
            progress.timestamp = progress.timestamp ? parseInt(progress.timestamp) : progress.timestamp;
            var keys = Object.keys(_this.progressService.levelsResults);
            lastSyncDate = lastSyncDate ? new Date(lastSyncDate) : null;
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                var el = _this.progressService.levelsResults[key];
                var elDate = new Date(el.date);
                if (!lastSyncDate || elDate > lastSyncDate) {
                    progress.level_results.push({
                        level_id: el.level_id || el.levelId,
                        date: elDate.toISOString(),
                        e_moves: el.e_moves,
                        l_moves: el.l_moves,
                        v_count: el.v_count
                    });
                }
            }
            _this.storageService.saveString('SyncDate', (new Date()).toISOString());
            return _this.http.post('/api/v1/sync/progress?token=' + _this.userToken, progress).toPromise();
        })
            .then(function (res) {
            if (!res) {
                return;
            }
            var progress = res.json();
            if (progress.is_reset) {
                _this.progressService.resetProgress();
            }
            _this.progressService.updateProgressBySync(progress);
            _this.storageService.saveString('SyncTimestamp', progress.timestamp);
            _this.eventService.fire('progressSynced');
        })
            .catch(function () {
            if (lastSyncDate) {
                _this.storageService.saveString('SyncDate', lastSyncDate);
            }
            else {
                _this.storageService.remove('SyncDate');
            }
        });
    };
    UserService.prototype.replaceProgress = function () {
        this.progressService.resetProgress();
        return this.sync();
    };
    UserService.prototype.resetProgress = function () {
        var _this = this;
        return this.userPromise
            .then(function () {
            if (!_this.authorized) {
                return;
            }
            return _this.http.delete('/api/v1/sync/progress?token=' + _this.userToken).toPromise();
        })
            .then(function (res) {
            var progress = res.json();
            _this.storageService.saveString('SyncTimestamp', progress.timestamp);
        });
    };
    return UserService;
}());
UserService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        progress_service_1.ProgressService,
        pack_level_service_1.PackLevelService,
        event_service_1.EventService,
        storage_service_1.StorageService])
], UserService);
exports.UserService = UserService;



//////////////////
// WEBPACK FOOTER
// ./src/services/user.service.ts
// module id = 264
// module chunks = 0